import { Component, OnInit, Input} from '@angular/core';
import { LFDynamicWidgetConfig } from '../../../models/lf-dynamic-widget-config';
import { AlertService } from 'sce-core';
import { ConfirmDialogService } from 'sce-core';
import { UserPreferenceService } from '../../../../layout/home/services/user-preference.service';
import { TablePreference } from '../../../search/models/table-preference.model';
import { CoreServiceRegistry } from '../../../../core/core-service-registry';
import { SharedServiceRegistry } from '../../../shared-service-registry';
import { ResourceService } from 'sce-core';
import { FormPageConfig } from '../../../models/form-page-config';
import { DetailedEntityDataService } from '../../../services/searchable-entity/detailed-entity/detailed-entity-data.service';
import { SearchService } from '../../../search/search.service';
import { DetailedEntityButtonService } from '../../../services/searchable-entity/detailed-entity/detailed-entity-button.service';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'lfwms-default-accordion-layout',
  templateUrl: './default-accordion-layout.component.html',
  styleUrls: ['./default-accordion-layout.component.css'],
  animations: [
    trigger('tabContent', [
      state('hidden', style({
        height: '0'
      })),
      state('visible', style({
        height: '*'
      })),
      transition('visible <=> hidden', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
    ])
  ]
})
export class DefaultAccordionLayoutComponent implements OnInit {

  @Input() public pageConfig: FormPageConfig;
  @Input() public widgetList: Array<LFDynamicWidgetConfig>;
  // @Output() reorder: EventEmitter<any> = new EventEmitter();

  public primaryAccordion: LFDynamicWidgetConfig;
  public secondaryAccordionList: Array<LFDynamicWidgetConfig>;
  // variable to decide whether to display secondary accordion or not
  public dispSecAcc = false;
  private reorderSourceKey: string;
  protected alertService: AlertService;
  protected confirmDialogService: ConfirmDialogService;
  protected resourceService: ResourceService;
  protected userPreferenceService: UserPreferenceService;
  private userPreference: TablePreference;
  public expandSecondaryAccordion= true;
  public expandDetailsAccordion = true;
  public panel: any;
  public default: any;
  public showDetailsSection: any;
  public detailAccordion: any;
  public dataService: DetailedEntityDataService;
  public buttonService: DetailedEntityButtonService;
  public get detailsSearchService(): SearchService {
    return this.dataService ? this.dataService.detailsSearchService : null;
  }


  constructor(private coreServiceRegistry: CoreServiceRegistry, private sharedServiceRegistry: SharedServiceRegistry) { }

  public ngOnInit() {
    this.alertService = this.sharedServiceRegistry.alertService;
    this.confirmDialogService = this.sharedServiceRegistry.confirmDialogService;
    this.resourceService = this.coreServiceRegistry.resourceService;
    this.userPreferenceService = this.coreServiceRegistry.userPreferencesService;
    this.userPreference = this.pageConfig.userPreference;
    this.dataService = this.pageConfig.dataService as DetailedEntityDataService;
    this.buttonService = this.pageConfig.buttonService as DetailedEntityButtonService;
    this.initializeAccordions();
  }

  private initializeAccordions() {
    // group the widgets into primary and secondary accordions
    if (this.widgetList) {
      this.secondaryAccordionList = [];
      this.widgetList.forEach((accordion: LFDynamicWidgetConfig) => {
        if (accordion.id === 'Primary') {
          this.primaryAccordion = accordion;
          this.primaryAccordion.isOpen = true;
          this.primaryAccordion.name = this.pageConfig.pageLabel;
        } else if (accordion.id === 'Details') {
          this.detailAccordion = accordion;
        } else {
          // close all non-primary by default.
          accordion.isOpen = this.pageConfig.openNonPrimaryWidgetsByDefault;
          this.secondaryAccordionList.push(accordion);
        }
      });
    }

    if (this.secondaryAccordionList && this.secondaryAccordionList.length > 0) {
      this.sortSecondaryAccordionList();
      this.dispSecAcc = true;
    }

    // if there is no default accordion specified, initialize a default one
    if (!this.detailAccordion) {
      this.detailAccordion = new LFDynamicWidgetConfig();
      this.detailAccordion.id = 'Details';
      this.detailAccordion.name = 'Details';
    }
  }

  // method used to translate the labels
  public getLabel(key: any) {
    return this.resourceService.get(key);
  }

  public toggleAccordionState(accordionConfig) {
    accordionConfig.isOpen = !accordionConfig.isOpen;
  }

  public toggleSecondaryAccordion() {
    this.expandSecondaryAccordion = !this.expandSecondaryAccordion;
  }

  public toggleDetailsAccordion() {
    this.expandDetailsAccordion = !this.expandDetailsAccordion;
  }

  public sortSecondaryAccordionList() {
    this.secondaryAccordionList
      .sort((a: any, b: any) => {
        if (a.activeIndex < b.activeIndex) {
          return -1;
        } else if (a.activeIndex > b.activeIndex) {
          return 1;
        } else {
          return 0;
        }
      });
  }

  public handleReorder(columnGroup: string, isDrop: boolean) {
    let reorderTargetKey: string;
    let temp: any;
    if (isDrop) {
      reorderTargetKey = columnGroup;
      if (reorderTargetKey === this.reorderSourceKey) {
        return;
      }
      temp = this.userPreference.columGroupConfig.configuration[this.reorderSourceKey];
      this.userPreference.columGroupConfig.configuration[this.reorderSourceKey]
        = this.userPreference.columGroupConfig.configuration[reorderTargetKey];
      this.userPreference.columGroupConfig.configuration[reorderTargetKey] = temp;
      this.secondaryAccordionList.forEach((config: any) => {
        config.activeIndex = this.userPreference.columGroupConfig.configuration[config.columnGroup];
      });
      this.userPreferenceService.saveTablePreferences(this.userPreference.columGroupConfig)
        .subscribe((data: any) => {
          if (!this.userPreference.columGroupConfig.preferenceId) {
            this.userPreference.columGroupConfig.preferenceId = data.preferenceId;
          }
          this.alertService.clearAll().success(this.resourceService.get('msg_usr_pref_succ'));
          this.sortSecondaryAccordionList();
        }, (error: any) => {
          this.alertService.clearAll().error(this.resourceService.get('msg_pref_sav_fail'));
        });
    } else {
      this.reorderSourceKey = columnGroup;
      this.secondaryAccordionList.forEach((accordionConfig: any) => {
        accordionConfig.isOpen = false;
      });
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/components/layout/default-accordion-layout/default-accordion-layout.component.ts